class GraduationController
{

    constructor ( apiService, toaster, authService )
    {
        'ngInject';

        Object.assign( this, { apiService, toaster, authService } )
    }

    $onInit ()
    {
        var user = this.authService.getUser();
        this.userName = user.firstName + ' ' + user.lastName;
    }

    async downloadCertificate ()
    {
        const userId = this.apiService.getData().user.id
        const response = await this.apiService.get( {
            url: `/api/v1/students/${ userId }/certificates`,
            name: 'certificate',
        } )
        if ( !response.certificate_url )
        {
            const newResponse = await this.apiService.post( {
                url: `/api/v1/students/${ userId }/certificates`,
                name: 'certificate',
            } )
            if ( newResponse.certificate_url )
            {
                const el = document.createElement( 'a' )
                el.href = newResponse.certificate_url
                el.target = '_blank'
                el.click()
            } else
            {
                this.toaster.pop( 'error', "Certificate creation failed", 'You have to finish your course first', 4000, 'trustedHtml' )
            }
        } else
        {
            const el = document.createElement( 'a' )
            el.href = response.certificate_url
            el.target = '_blank'
            el.click()
        }
    }
}

export default GraduationController;



// WEBPACK FOOTER //
// ./client/app/modules/graduation/graduation.controller.js